export default __webpack_public_path__ + "static/img_measure@2x-c19c23c283e7679e5a7fd59c9bcebf81.png";